var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsCodepipelineLgo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 81,
    viewBox: "0 0 71 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.193 50.442L0.187988 54.559L10.019 68.588L46.405 51.759L35.194 50.442H35.193Z",
    fill: "#B7CA9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1929 30.558L70.1879 26.441L60.3569 12.412L23.9709 29.232L35.1929 30.559V30.558Z",
    fill: "#3C4929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.971 29.232L60.357 23.651V12.412L23.971 21.729V29.231V29.232ZM0.187988 45.183L35.193 48.5L69.528 40.5L35.193 32.5L0.187988 35.807V45.183Z",
    fill: "#4B612C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.188 45.183L35.193 48.5V32.5L70.188 35.807V45.183Z",
    fill: "#759C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.187988 26.442L35.193 0.5L53.824 21.788L17.17 28.442L0.187988 26.442Z",
    fill: "#3C4929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.187988 17.066L35.193 0.5V16.5L0.187988 26.442V17.066V17.066Z",
    fill: "#4B612C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.357 12.412L70.188 17.066V26.442L60.357 23.652V12.412ZM46.405 51.759L10.019 57.349V68.588L46.405 59.261V51.759V51.759ZM53.824 21.788L35.193 16.5V0.5L53.824 9.32V21.788V21.788Z",
    fill: "#759C3E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.188 54.559L35.193 80.501L16.562 59.203L53.206 52.559L70.188 54.559V54.559Z",
    fill: "#B7CA9D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.188 63.925L35.193 80.501V64.501L70.188 54.559V63.925Z",
    fill: "#759C3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.562 59.202L35.193 64.5V80.5L16.562 71.68V59.202V59.202ZM10.019 68.588L0.187988 63.925V54.559L10.019 57.349V68.588Z",
    fill: "#4B612C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCodepipelineLgo);
export default __webpack_public_path__ + "static/media/aws-codepipeline-lgo.062e11acd1523e5d96df663054c03572.svg";
export { ForwardRef as ReactComponent };